import { render, staticRenderFns } from "./MyLib_phone.vue?vue&type=template&id=0ce80d5e&scoped=true"
import script from "./MyLib_phone.vue?vue&type=script&lang=js"
export * from "./MyLib_phone.vue?vue&type=script&lang=js"
import style0 from "./MyLib_phone.vue?vue&type=style&index=0&id=0ce80d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce80d5e",
  null
  
)

export default component.exports